export default "__VITE_ASSET__C4KG6nZF__"